module.exports = __webpack_public_path__ + "img/prairiedogthumb.e77c59cf.jpg";